/* eslint-disable react-hooks/exhaustive-deps */
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import CelebrationOutlinedIcon from '@mui/icons-material/CelebrationOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
import { Box } from "@mui/material";
import i18next from 'i18next';
import { useEffect, useState } from "react";
import Countdown from 'react-countdown';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../../constants/appRoutes";
import { WBTextType } from '../../../constants/welcomeBonusTextTypes';
import { buildLocalizeRoute } from "../../../helpers/languageHelper";
import { ObjectNameFormatter } from '../../../helpers/objectNameFormatter';
import { convertToHours } from '../../../helpers/welcomeBonusTimeHelper';
import { getUser } from "../../../services/authService";
import { UserService } from "../../../services/userService";
import { Toaster } from "../common/toaster";
import { ButtonWrapper } from "../formUtilities/useButton";
import { TextWrapper } from '../formUtilities/useTextWrapper';

const sprintDate = process.env.REACT_APP_ENV === 'prod' ? '2025-02-24' : '2025-02-22';

export const CashbackBanner = ({ onLayoutChange = null }) => {
  const { t } = useTranslation();
  const userService = new UserService();
  const [welcomeBonus, setWelcomeBonus] = useState(null);
  const { settings } = useSelector(
    (state) => state.systemSettingsDataReducer
  );
  const [loading, setLoading] = useState(true);
  const [coupon, setCoupon] = useState(null);
  const [isAllDocUploaded, setIsAllDocUploaded] = useState(false);
  const [isTimeExpired, setIsTimeExpired] = useState(false);
  const navigate = useNavigate();
  const user = getUser();

  const [targetDate, setTargetDate] = useState(null);

  const isNewUser = () => {
    if (!user?.signUpDate) {
      return false;
    }

    return new Date(user?.signUpDate) >= new Date(sprintDate); //sprint 83 deployment date;
  };

  useEffect(() => {
    if (settings && settings?.enabledWelcomeBonus) {
      setWelcomeBonus(ObjectNameFormatter(JSON.parse(settings?.enabledWelcomeBonus)));
    }
  }, [settings]);

  useEffect(() => {
    // Whenever any condition changes, notify the parent
    onLayoutChange && onLayoutChange();
  }, [isNewUser(), isTimeExpired, loading, user?.isApproved, coupon]);

  useEffect(() => {
    if (isNewUser() && welcomeBonus?.enabled) {
      getDocumentUploadStatus();
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, [welcomeBonus]);

  const handleCopy = () => {
    navigator.clipboard.writeText(coupon?.code);
    Toaster({ msg: "Copied...", isError: false });
  };

  const isApprovedAndUploaded = () => {
    return user?.isApproved && isAllDocUploaded;
  };

  const getCouponList = () => {
    return userService.getCouponList();
  };

  const getDocumentUploadStatus = () => {
    userService.getDocumentStatus().then(async resp => {
      const hasUploadedAllDocuments = resp.data?.hasUploadedAllDocuments;
      setIsAllDocUploaded(hasUploadedAllDocuments);
      const time = convertToHours(welcomeBonus?.documentsUploadedMaxOffset || '2.00:00:00') || 48;
      let date = new Date(`${user?.signUpDate}T00:00:00.000Z`);
      let utcTime = date.getTime();
      date.setTime(utcTime + time * 60 * 60 * 1000);
      setTargetDate(date);
      if (hasUploadedAllDocuments) {
        if (user?.isApproved) {
          const couponList = await getCouponList();
          const promoCode = couponList.data[0] || null;
          setCoupon(promoCode);
          if (promoCode?.expiryDate) {
            date = new Date(promoCode?.expiryDate);
            // utcTime = date.getTime();
            // console.log(utcTime);
            // date.setTime(utcTime * 24 * 60 * 60 * 1000);
          }
          setLoading(false);
          setTargetDate(date);
        } else {
          setLoading(false);
          setTargetDate(null);
        }
      } else {
        setLoading(false);
      }
    }).catch(err => {
      setLoading(false);
    });
  };

  if (!isNewUser() || isTimeExpired || loading || (user?.isApproved && !coupon?.code) || !welcomeBonus?.enabled) {
    return <></>;
  }

  const getCountdownSection = (value, label) => {
    return <Box className='flex flex-col justify-center'>
      <Box className='border text-secondary border-solid bg-white font-semibold w-[30px] h-[30px] rounded-md flex justify-center items-center'>{value}</Box>
      <Box className='!text-white !text-[7px] mt-0.5 !font-semibold text-center capitalize'>{t(label)}</Box>
    </Box>;
  };

  const getCurrentHeadingAndIcon = () => {
    let headingAndIcon = { heading: "", subText: "", icon: null };
    if (!isAllDocUploaded) {
      headingAndIcon = {
        heading: welcomeBonus?.texts?.[`${WBTextType.docUploadBanner}_${i18next.language}`]?.title,
        subText: welcomeBonus?.texts?.[`${WBTextType.docUploadBanner}_${i18next.language}`]?.content, icon: <DiamondOutlinedIcon className='!text-secondary' />
      };
    } else if (user?.isApproved) {
      headingAndIcon = {
        heading: welcomeBonus?.texts?.[`${WBTextType.promoCodeAvailableBanner}_${i18next.language}`]?.title, subText: welcomeBonus?.texts?.[`${WBTextType.promoCodeAvailableBanner}_${i18next.language}`]?.content, icon: <CelebrationOutlinedIcon className='!text-secondary' />
      };
    } else {
      headingAndIcon = { heading: welcomeBonus?.texts?.[`${WBTextType.approvalPendingBanner}_${i18next.language}`]?.title, subText: welcomeBonus?.texts?.[`${WBTextType.approvalPendingBanner}_${i18next.language}`]?.content, icon: <AccessTimeOutlinedIcon className='!text-secondary' /> };
    }
    return headingAndIcon;
  };

  return <Box className='min-h-[60px] md:top-[130px] top-[80px] flex justify-center items-center z-[99] fixed left-0 right-0  w-full p-2 bg-[#f5f5f5]'>
    <Box id="mp-announcement-bar" className={`min-h-[40px] md:rounded-md md:top-[138px] top-[80px] flex justify-center items-center z-[99] fixed md:-translate-x-1/2 md:w-[1140px] w-full px-3 py-2 text-start shadow-sm secondary-bg !text-white !text-[14px] !font-[500] md:left-[calc(50%-8px)]`}>
      <Box className='xl:w-[1140px] w-full flex md:flex-row flex-col md:items-center items-start justify-between'>
        <Box className='flex flex-row items-center'>
          <Box>
            {getCurrentHeadingAndIcon().heading ?
              <Box className='text-[14px] !font-bold'><span>{getCurrentHeadingAndIcon().heading}</span></Box>
              : null}
            {getCurrentHeadingAndIcon().subText ? <Box className='!text-[13px]'>
              {getCurrentHeadingAndIcon().subText}
            </Box> : null}
          </Box>
        </Box>
        <Box className='w-4'></Box>
        <Box className='flex flex-row items-center md:justify-start justify-between md:w-auto w-full md:mt-0 mt-2'>
          {targetDate ? <Countdown
            date={targetDate}
            intervalDelay={0}
            precision={3}
            autoStart
            onComplete={() => {
              setIsTimeExpired(true);
            }}
            renderer={({ days, hours, minutes, seconds, completed }) => {
              return completed ? null : <Box className='flex items-center mt-2 relative'>
                {getCountdownSection(days, days > 1 ? 'days' : 'day')}
                <Box className='mx-2 font-bold relative -top-[5px]'>:</Box>
                {getCountdownSection(hours, 'hours')}
                <Box className='mx-2 relative -top-[5px] font-bold'>:</Box>
                {getCountdownSection(minutes, 'minutes')}
                <Box className='w-5'></Box>
              </Box>;
            }}
          /> : null}
          <Box className='mt-3 md:mt-0'>
            {!isApprovedAndUploaded() ?
              !isAllDocUploaded ? <ButtonWrapper onClick={() => {
                navigate(buildLocalizeRoute(`${AppRoutes.Investor}/${AppRoutes.Profile}/${AppRoutes.IProfileUpdate}`));
              }} labelClass="!text-secondary" variant={'outlined'} classList="!bg-white" label={t('completeSignUpBonus')} /> :
                <TextWrapper classList='!text-[13px] !font-[500]' text={t('accountUnderReview')} />
              : coupon ?
                <Box onClick={() => {
                  handleCopy();
                }} className={`flex items-center text-[13px] rounded-md cursor-pointer border px-3 relative py-1 border-dashed border-[#ccc] hover:opacity-80`}>
                  <ContentCopyOutlinedIcon className="!text-[16px] mx-1" />
                  <Box className='font-bold'>{t('copyCode')}</Box>
                </Box> : null
            }
          </Box>
        </Box>
      </Box>
    </Box>
  </Box>;
};